import { PUT_FAQ_START } from '../../types';

export const put_faqs = (payload) => ({
  type: PUT_FAQ_START,
  payload,
});
